module.exports = __webpack_public_path__ + "static/media/pixel mall shot 01-mobile.1387f515.webp";